<script setup>
const props = defineProps({
  products: {
    type: Array,
  },
  title: {
    type: String,
  },
});
</script>
<template>
  <h4 v-if="title" class="text-lg font-semibold mb-3">{{ title }}</h4>
  <div class="flex flex-row gap-4 overflow-x-auto pb-2" v-if="products && products.length">
    <div v-for="(item, i) in products" :key="i" class="flex-shrink-0 w-[280px]">
      <div class="bg-white rounded-lg p-2 shadow-sm hover:shadow-md transition-shadow">
        <ProductBoxProductBox1 :item="item" :index="i" />
      </div>
    </div>
  </div>
</template>
<style scoped>
/* Tailwind classes used - no custom CSS needed */
</style>
